import {useEffect} from 'react';
import TabClose from '../../assets/icon/tab_close.svg';
import Globe from '../../assets/icon/globe.svg';

const NoShow = () => {
    useEffect(() => {
        const prevTitle = document.title;
        const favicon = document.querySelector("link[rel='icon']");
        const prevFaviconHref = favicon ? favicon.getAttribute('href') : null;

        document.title = '無法顯示';
        if (favicon) {
            favicon.setAttribute('href', Globe);
        }

        return () => {
            document.title = prevTitle;
            if (favicon && prevFaviconHref !== null) {
                favicon.setAttribute('href', prevFaviconHref);
            }
        };
    }, []);

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '75vh',
            }}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    textAlign: 'left',
                    maxWidth: '600px',
                    width: '80%',
                }}>
                <img src={TabClose} alt='tab_close' style={{width: '48px', marginBottom: '16px'}} />
                <h2 style={{color: '#202124', fontWeight: '500'}}>無法連上這個網站</h2>
                <p style={{color: '#5f6368'}}>連線已重設。</p>
                <div style={{color: '#5f6368'}}>建議做法:</div>
                <div style={{color: '#5f6368'}}>檢查連線狀態</div>
                <p style={{color: '#5f6368'}}>ERR_CONNECTION_TRESET</p>
            </div>
        </div>
    );
};

export default NoShow;
